module.exports = __webpack_public_path__ + "img/publicNotic.41ad1e84.png";